import { render, staticRenderFns } from "./UploadPictures.vue?vue&type=template&id=ef27e386&"
import script from "./UploadPictures.vue?vue&type=script&lang=js&"
export * from "./UploadPictures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports